<template>
    <page>
        <template slot="content">
            <div class="row p-3 pb-0">
                <div class="col-3">
                    <BemVindo></BemVindo>
                </div>
                <div class="col-9">
                    <CardContadores></CardContadores>
                </div>
            </div>
            <div class="row p-3 pt-0" style="padding-top: 0px!important">
                <div class="col-7">
                    <AtendimentoPorCriticidade></AtendimentoPorCriticidade>
                </div>
                <div class="col-5">
                    <ProdutividadeMecanico></ProdutividadeMecanico>
                </div>
            </div>
            <div class="row p-3 pt-0" style="padding-top: 0px!important">
                <div class="col-3">
                    <PlacasMaisAtendidas></PlacasMaisAtendidas>
                </div>
                <div class="col-9">
                    <PlacasPreventivas></PlacasPreventivas>
                </div>
            </div>
            <div class="row p-3 pt-0" style="padding-top: 0px!important">
                <div class="col-8">
                    <ProblemasMaisAtendidos></ProblemasMaisAtendidos>
                </div>
                <div class="col-4">
                    <OrdemServicoFornecedor></OrdemServicoFornecedor>
                </div>
            </div>
            <!-- <div class="row p-3 pt-0" style="padding-top: 0px!important">
                <div class="col-12">
                    <NotasMecanicos></NotasMecanicos>
                </div>
            </div> -->
        </template>
    </page>
</template>

<script>
import Page from '@/components/Page'
import BemVindo from '../components/Dashboard/BemVindo.vue'
import CardContadores from '../components/Dashboard/CardContadores.vue'
import AtendimentoPorCriticidade from '../components/Dashboard/AtendimentoPorCriticidade.vue'
import ProdutividadeMecanico from '../components/Dashboard/ProdutividadeMecanico.vue'
import PlacasMaisAtendidas from '../components/Dashboard/PlacasMaisAtendidas.vue'
import PlacasPreventivas from '../components/Dashboard/PlacasPreventivas.vue'
import OrdemServicoFornecedor from '../components/Dashboard/OrdemServicoFornecedor.vue'
import ProblemasMaisAtendidos from '../components/Dashboard/ProblemasMaisAtendidos.vue'
// import NotasMecanicos from '../components/Dashboard/NotasMecanicos.vue'

export default {
  components: {
    Page,
    BemVindo,
    CardContadores,
    AtendimentoPorCriticidade,
    ProdutividadeMecanico,
    PlacasMaisAtendidas,
    PlacasPreventivas,
    OrdemServicoFornecedor,
    ProblemasMaisAtendidos,
    // NotasMecanicos
},

  data() {
    return {
    }
  },

  computed: {
  },

  mounted() {

  },

  methods: {
    
  }
}
</script>

<style lang="scss" scoped>
.card {
    border-radius: 25px;
    background: #ffffff !important;
    padding: 20px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    flex-direction: row;
}
</style>
